export default __webpack_public_path__ + "static/media/FrameworkFoundation.256.a2316d01.png";